/// <amd-module name="WorkItemsHub/ZeroData/ZeroDataFactory" />
import * as React from "react";
import * as WorkItemsHubTabUtils from "WorkItemsHub/Utils/WorkItemsHubTabUtils";
//import * as Diag from "VSS/Diag";
import * as Resources from "WorkItemsHub/Resources";
import * as WorkItemTrackingZeroDataUtils from "WorkItemsHub/ZeroData/WorkItemTrackingZeroDataUtils";
import { ZeroData } from "VSSUI/ZeroData";
import { WorkItemsHubTabs } from "WorkItemsHub/Generated/Constants";
import { GeneralZeroDataIllustrationPaths } from "WorkItemsHub/ZeroData/IllustrationUrlUtils";
import { GenericFilterZeroData } from "WorkItemsHub/ZeroData/GenericFilterZeroData";
import { getAssetLocation } from "VSS/Platform/Location";

type CreateZeroData = (isSupportedFeature?: boolean, pageContext?: any) => JSX.Element;

export namespace ZeroDataFactory {
    const KnownCreateMethods: { [key: number]: CreateZeroData } = {
        [WorkItemsHubTabs.AssignedToMe]: (pageContext: any) => WorkItemTrackingZeroDataUtils.createForAssignedToMe(pageContext),
        [WorkItemsHubTabs.MyActivity]: (pageContext: any) => WorkItemTrackingZeroDataUtils.createForMyActivity(pageContext),
        [WorkItemsHubTabs.RecentlyUpdated]: (pageContext: any) => WorkItemTrackingZeroDataUtils.createForRecentlyUpdated(pageContext),
        [WorkItemsHubTabs.Following]: (pageContext: any, isSupportedFeature: boolean) => isSupportedFeature ?
            WorkItemTrackingZeroDataUtils.createForFollowing(pageContext) : WorkItemTrackingZeroDataUtils.createForFollowingNotconfigured(pageContext),
        [WorkItemsHubTabs.Mentioned]: (pageContext: any) => WorkItemTrackingZeroDataUtils.createForMentioned(pageContext),
        [WorkItemsHubTabs.RecentlyCreated]: (pageContext: any) => WorkItemTrackingZeroDataUtils.createForRecentlyCreated(pageContext),
        [WorkItemsHubTabs.RecentlyCompleted]: (pageContext: any) => WorkItemTrackingZeroDataUtils.createForRecentlyCompleted(pageContext),
        [WorkItemsHubTabs.MyTeams]: (pageContext: any, isSupportedFeature: boolean) => isSupportedFeature ?
            WorkItemTrackingZeroDataUtils.createForMyTeams(pageContext) : WorkItemTrackingZeroDataUtils.createForMyTeamsNotconfigured(pageContext)
    };

    export function createForEmptyData(tabId: string, isSupportedFeature: boolean, fromFilter: boolean = false, pageContext: any): JSX.Element {
        if (fromFilter) {
            // Use same zero data filter experience
            return <GenericFilterZeroData artifactName={Resources.ZeroData_Filter_WorkItems_ArtifactName} pageContext={pageContext} />;
        }

        // Get Zero Day experience
        const createMethod: CreateZeroData = KnownCreateMethods[WorkItemsHubTabUtils.TabEnumValueByTabIdMap[tabId]];

        if (!!createMethod) {
            return createMethod(pageContext, isSupportedFeature);
        }

        return null;
    }

    export function createForMissingTabData(pageContext: any): JSX.Element {
        return <ZeroData
            primaryText={Resources.UnableToLoadHubData}
            imagePath={getAssetLocation(pageContext, GeneralZeroDataIllustrationPaths.SomethingWrongOnServer)}
            imageAltText={Resources.Illustrations_SomethingWrongOnServerAltText} />;
    }

    export const createForServerError = WorkItemTrackingZeroDataUtils.createForServerError;
}
